import { BuyerDetailModel } from './buyer.detail.model';

export class PagedBuyerDetailModel {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: BuyerDetailModel[] = [];
}
